<div class="homepage">
    <!-- Hero Section -->
    <section class="hero">
        <div class="hero-bg"></div>
        <div class="hero-content">
            <div class="hero-badge animate-fade-in">
                <span>🚀 Innovating Since 2011</span>
            </div>
            <h1 class="hero-title animate-fade-in animate-delay-1">
                Building the Future of<br>
                <span class="gradient-text">Software Solutions</span>
            </h1>
            <p class="hero-subtitle animate-fade-in animate-delay-2">
                KSolve delivers cutting-edge, scalable, and secure mobile and web applications.
                Our expertise in academics, business, and human interface design empowers
                innovative solutions.
            </p>
            <div class="hero-cta animate-fade-in animate-delay-3">
                <button mat-flat-button class="cta-primary" routerLink="/courses">
                    <mat-icon>school</mat-icon>
                    Browse Courses
                </button>
                <button mat-stroked-button class="cta-secondary" routerLink="/contact-us">
                    Contact Us
                    <mat-icon>arrow_forward</mat-icon>
                </button>
            </div>
        </div>
        <div class="hero-visual animate-fade-in animate-delay-4">
            <div class="floating-card card-1" routerLink="/courses" role="button" tabindex="0">
                <mat-icon>school</mat-icon>
                <span>K-12 Education</span>
            </div>
            <div class="floating-card card-2" (click)="goToMwm()" role="button" tabindex="0">
                <mat-icon>psychology</mat-icon>
                <span>Math With Meenu</span>
            </div>
            <div class="floating-card card-3">
                <mat-icon>devices</mat-icon>
                <span>Cross Platform</span>
            </div>
        </div>
    </section>

    <!-- Services Section -->
    <section class="services-section">
        <div class="section-container">
            <h2 class="section-title">What We Build</h2>
            <p class="section-subtitle">Comprehensive solutions tailored to your needs</p>

            <div class="services-grid">
                <div class="service-card" *ngFor="let service of services; let i = index"
                    [class.visible]="visibleCards[i]"
                    [class.clickable]="!!service.link"
                    (click)="onServiceClick(service)"
                    [attr.role]="service.link ? 'button' : null"
                    [attr.tabindex]="service.link ? 0 : null">
                    <div class="service-icon">
                        <mat-icon>{{service.icon}}</mat-icon>
                    </div>
                    <div class="service-title-row">
                        <h3>{{service.title}}</h3>
                        <mat-icon class="service-external-icon" *ngIf="service.isExternal">open_in_new</mat-icon>
                        <mat-icon class="service-arrow-icon" *ngIf="service.link && !service.isExternal">arrow_forward</mat-icon>
                    </div>
                    <p>{{service.description}}</p>
                </div>
            </div>
        </div>
    </section>

    <!-- CTA Section -->
    <section class="cta-section">
        <div class="section-container">
            <div class="cta-card">
                <h2>Ready to Transform Your Ideas?</h2>
                <p>Let's build something amazing together. Get in touch with our team today.</p>
                <button mat-flat-button class="cta-primary" routerLink="/contact-us">
                    Contact Us
                    <mat-icon>arrow_forward</mat-icon>
                </button>
            </div>
        </div>
    </section>
</div>